// ✅ RefinanceForm.jsx — Main Multi-Step Flow Controller (with Cool Progress Bar)
import React, { useState } from "react";
import styles from "./RefinanceForm.module.css";
import ProgressBar from "./ProgressBar"; // 👈 new progress bar

// ✅ Steps
import RefinanceStart from "./RefinanceStart";     // Step 1 – Mobile + OTP
import RefinanceGoal from "./RefinanceGoal";       // Step 2 – Refinance goals
import LoanDetails from "./LoanDetails";           // Step 3 – Property & Loan Info
import ApplicantDetails from "./ApplicantDetails"; // Step 4 – Applicant info
import Income from "./Income";                     // Step 5 – Income details
import Liabilities from "./Liabilities";           // Step 6 – Liabilities / Debts
import SummarySubmit from "./SummarySubmit";       // Step 7 – Review + Submit

function RefinanceForm() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({ applicant1: {} });

  const totalSteps = 7;
  const nextStep = () => setStep((prev) => prev + 1);
  const prevStep = () => setStep((prev) => prev - 1);

  // 🧭 Step label mapping for display
  const stepLabels = [
    "Mobile Verification",
    "Refinance Goal",
    "Loan Details",
    "Applicant Details",
    "Income",
    "Liabilities",
    "Review & Submit",
  ];

  return (
    <div className={styles.refinanceContainer}>
      {/* ✅ Progress Bar with Step Name */}
      <ProgressBar step={step} totalSteps={totalSteps} stepLabels={stepLabels} />

      {/* Step 1 — OTP Verification */}
      {step === 1 && (
        <RefinanceStart
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
        />
      )}

      {/* Step 2 — Refinance Goal */}
      {step === 2 && (
        <RefinanceGoal
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {/* Step 3 — Loan Details */}
      {step === 3 && (
        <LoanDetails
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {/* Step 4 — Applicant Details */}
      {step === 4 && (
        <ApplicantDetails
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {/* Step 5 — Income */}
      {step === 5 && (
        <Income
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {/* Step 6 — Liabilities */}
      {step === 6 && (
        <Liabilities
          formData={formData}
          setFormData={setFormData}
          nextStep={nextStep}
          prevStep={prevStep}
        />
      )}

      {/* Step 7 — Summary + Submit */}
      {step === 7 && (
        <SummarySubmit
          formData={formData}
          setFormData={setFormData}
          prevStep={prevStep}
        />
      )}
    </div>
  );
}

export default RefinanceForm;
